export default __webpack_public_path__ + "static/media/quickpay.a99254c1.svg";